<template>
  <div class="">
    <div class="row">
      <div class="col-md-12 col-sm-8">
        <div class="card card-default widget animated">
          <div class="card-heading">
            <!--Viewing-->
            <div class="UserViewing" v-show="!isEditing">
              <div class="form-group col-md-5">
                <p style="font-size:35px">{{user.name}}</p>
                <p>{{user.active == true ? 'Active': 'Inactive'}}</p>
                <p>{{user.emailnotif == true ? 'Email Alerts Enabled': 'Email Alerts Disabled'}}</p>
                <p>{{user.chat == true ? 'Wire is Enabled': 'Wire is Disabled'}}</p>
                <div v-for="r in roles">
                  <p v-if="r['.key'] == user.role">{{r.name}}</p>
                </div>
                <br>

                <button v-on:click="edit" v-if="org['curOrg']['role'] == '1' || org['curOrg']['role'] == 99" type="button" class="btn  btn-default form-group">Edit</button>
              </div>
            </div>
            <!--Editing-->
            <div class="UserEditing col-md-5" v-show="isEditing">
              <p style="font-size:35px">{{user.name}}</p>
              <hr/>
              <form-checkbox label="Active" name="active" v-model="userEdit.active"></form-checkbox>
              <br>
              <h5>Wire</h5>
              <form-checkbox label="Wire" name="chat" v-model="userEdit.chat"></form-checkbox>
              <br>
              <form-select label = "Role" name="role" v-model="userEdit.role" :options="roles"></form-select>
              <br>
              <div class="form-group">
                <button v-on:click="cancelEdit" type="button" class="btn  btn-default">Cancel</button>
                <button v-on:click="submitEdit" type="button" class="btn  btn-success">Submit</button>
              </div>
            </div>
          </div>
        </div>
      </div><!-- /.col-md-12 -->
    </div><!-- /.col-md-3 -->
  </div>
</template>

<script>
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import VueMask from 'v-mask'
import ActiveFormCheckbox from '../../elements/Form/ActiveFormCheckbox'
import FormSelect from '../../elements/Form/FormSelect'
import database from '../../webmaster/Database/database'
import store from '../../webmaster/Store/vuex'

Vue.use(VueMask);
Vue.use(VeeValidate);

export default {
  name: 'userdetail',
  components:{
    'form-checkbox':ActiveFormCheckbox,
    'form-select':FormSelect
  },
  data () {
    return {
      user:{},
      userEdit:{},
      isEditing: false,
      roles: [],
      org: store.state.usermain,
    }
  },
  created:function(){
    this.fetchUser()
    this.fetchRoles()
  },
  methods: {
    edit: function(){
      this.isEditing = true;
    },
    cancelEdit: function(){
      this.isEditing = false;
    },
    fetchUser: function(){
      this.$bindAsObject('user', database.getRef('/orgs/' + this.$store.state.usermain.curOrg.id + '/users/' + this.$route.params.id), null, function(){
        this.userEdit = Object.assign({}, this.userEdit, this.user);
      });
    },
    fetchRoles: function(){
      this.$bindAsArray('roles', database.getRef('/roles'), null, function(){
        var index = this.roles.indexOf("99");

        this.roles.splice(index, 1);
      });
    },
    submitEdit: function(){
      let promises = [];
      var self = this;
      for (let child in this.$refs) promises.push(this.$refs[child].$validator.validateAll());
      Promise.all(promises).then(this.$validator.validateAll()).then(() => { 
        this.updateRoleOrgs(database.getDb().ref(), self.userEdit['.key'], self.userEdit.role, self.userEdit.active, self.$store.state.usermain.curOrg.id, self.userEdit.chat, self.user.name).then(function() {
          self.user = Object.assign({}, self.user, self.userEdit);
          console.log(self.user)
          self.isEditing = false;

          self.$router.push('/admin/users')
        }).catch(err => {
          console.log(err)
        });
      }, () => {});
    },
    updateRoleOrgs: function(rootRef, uid, role, active, org, chat, userName){
      let updateObj = {}
      updateObj['/orgs/' + org + '/users/' + uid + '/role'] = role
      updateObj['/users/' + uid + '/orgs/' + org + '/role'] = role
      updateObj['/orgs/' + org + '/users/' + uid + '/active'] = active
      updateObj['/users/' + uid + '/orgs/' + org + '/active'] = active

      if (active == false) {
        updateObj['/orgs/' + org + '/users/' + uid + '/emailnotif'] = false
        updateObj['/users/' + uid + '/orgs/' + org + '/emailnotif'] = false
      }

      if (chat != null && chat != undefined) {
        updateObj['/orgs/' + org + '/users/' + uid + '/chat'] = chat
        updateObj['/users/' + uid + '/orgs/' + org + '/chat'] = chat
      }

      return database.getRef("/orgs/" + org + "/wire/users/" + uid).once('value').then(wireUserSnapshot => {
        if (wireUserSnapshot.val() == null && chat == true) {
          updateObj["/orgs/" + org + "/wire/users/" + uid] = {
            name: userName,
            user_type: "mobile",
          };
        }
      }).then(function() {
        return rootRef.update(updateObj)
      })

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// UserDetail.vue?a6cd89b6